module.exports = __webpack_public_path__ + "img/lk-mode-credit-card-grey.cfec8471.svg";